import { UPDATE_DMX_DEVICE, UPDATE_DMX_DEVICE_SUCCESSFUL, UPDATE_DMX_DEVICE_FAILED } from './actionTypes';

const initialState = {
  updateDmxDeviceError: null,
  messageDmxDevice: null,
  loadingUpdateDmxDevice: false,
};

const updateDevice = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DMX_DEVICE:
      state = { ...state, loadingUpdateDmxDevice: true, updateDmxDeviceError: null };
      break;
    case UPDATE_DMX_DEVICE_SUCCESSFUL:
      state = { ...state, loadingUpdateDmxDevice: false, messageDmxDevice: action.payload, updateDmxDeviceError: null };
      break;
    case UPDATE_DMX_DEVICE_FAILED:
      state = { ...state, messageDmxDevice: null, loadingUpdateDmxDevice: false, updateDmxDeviceError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateDevice;
